import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Muro } from '../models/muro.model';

@Injectable({
  providedIn: 'root'
})
export class MuroService {

  private muroSource = new BehaviorSubject<Muro[]>([]);
  muro$ = this.muroSource.asObservable();

  // 🔥 PAGINACIÓN
  public page = 1;
  public limit = 10;
  public loading = false;
  public hasMore = true;
  public tipo: string = "";

  get muroActual(): Muro[] {
    return this.muroSource.value;
  }

  // =========================
  // 📌 PAGINACIÓN
  // =========================

  get estadoPaginacion() {
    return {
      page: this.page,
      limit: this.limit,
      loading: this.loading,
      hasMore: this.hasMore
    };
  }

  setLoading(value: boolean) {
    this.loading = value;
  }

  resetPaginacion() {
    this.page = 1;
    this.hasMore = true;
    this.loading = false;
    this.muroSource.next([]);
  }

  // Primera carga
  setMuro(data: Muro[]) {
    this.muroSource.next(data);
    this.page = 2;
    this.hasMore = data.length === this.limit;
  }

  getMuro() {
    return this.muroSource.value;
  }

  // Cargar más (append)
  appendMuro(data: Muro[]) {

    if (!data || data.length === 0) {
      this.hasMore = false;
      return;
    }

    const actual = this.muroActual;

    // evitar duplicados por seguridad
    const ids = new Set(actual.map(x => x.rs_id));
    const nuevos = data.filter(x => !ids.has(x.rs_id));

    this.muroSource.next([...actual, ...nuevos]);

    this.page++;

    if (data.length < this.limit) {
      this.hasMore = false;
    }
  }

  // =========================
  // 📌 CRUD MURO
  // =========================

  agregar(nuevo: Muro) {
    this.muroSource.next([nuevo, ...this.muroActual]);
  }

  actualizar(actualizado: Muro) {
    const lista = this.muroActual.map(item =>
      item.rs_id === actualizado.rs_id ? actualizado : item
    );
    this.muroSource.next(lista);
  }

  eliminar(rs_id: number) {
    const lista = this.muroActual.filter(item => item.rs_id !== rs_id);
    this.muroSource.next(lista);
  }

  limpiar() {
    this.resetPaginacion();
  }

  // =========================
  // 📌 FACTORY / HELPERS
  // =========================

  crearMuroVacio(): Muro {
    return {
      first_name: '',
      foto_principal_grande: '',
      foto_principal_thumb: '',
      slug: '',
      mascotas: [],

      nuevo: false,
      rs_id: 0,
      rs_us_id: 0,
      rs_parent_id: 0,

      rs_tipo_publicacion: "'','01','02','03','04','05'",
      tipopublicacion: '',
      rs_tipo: '',
      rs_tipo_id: 0,
      rs_ma_id: 0,

      rs_fechahora: new Date().toISOString(),
      rs_cuando: '',

      rs_texto: '',

      rs_geolat: 0,
      rs_geolon: 0,

      rs_ciudad: '',
      rs_estado: '',
      rs_pais: '',
      rs_cdpostal: '',

      rs_fecha_paseo: '',
      rs_hora_paseo: '',
      rs_lugar_paseo: '',
      paseo: { rsp_id: 0, rsp_rs_id: 0, rsp_fecha: '', rsp_hora: '', rsp_ubicacion: '' },
      servicio: { rsse_id: 0, rsse_rs_id: 0, rsse_tipo: '', rsse_rol: '', va_nombre: '' },
      encuesta: [],
      rs_participantes_paseo: 0,
      miparticipacionpaseo: false,

      rs_alcance: '',

      rs_fotos: [],

      huellas: 0,
      usuarioshuella: [],
      mihuella: 0,

      showpublicar: false,
      showeditar: false,

      comentarios: [],
      totalcomentarios: 0,
      numcomentarios: 0,

      page: 1,
      pageComentarios: 1,
      offsetComentarios: 0,

      loadingComentarios: false,
      noMasComentarios: false,

      borrada: false,
      nivel: 0,
      comentario: false,

      imagenes: [],
      previewUrl: [],
      //parent: 

      novisible: ''
    };
  }

  resetearMuro(muro: Muro): Muro {
    return {
      ...this.crearMuroVacio(),
      rs_id: muro.rs_id,
      rs_us_id: muro.rs_us_id
    };
  }

  limpiarParent(muro: any): any {
    const copia = { ...muro };

    delete copia.parent;

    if (copia.comentarios) {
      copia.comentarios = copia.comentarios.map((c: any) =>
        this.limpiarParent(c)
      );
    }

    return copia;
  }

  agregarComentario(rs_id: number, comentario: any) {

    const lista = this.muroActual.map(item => {

      if (item.rs_id !== rs_id) return item;

      return {
        ...item,
        comentarios: [...(item.comentarios || []), comentario],
        numcomentarios: (item.numcomentarios || 0) - 1,
        page: comentario.page
      };
    });

    this.muroSource.next(lista);
  }
}